/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';

import * as Layout from '@components/screen/Layout';
import SelectBox from '@components/form/SelectBox';
import SociollaText from '@components/sociolla/SociollaText';
import SociollaCard from '@components/sociolla/SociollaCard';
import CardHeaderCustom from '@/screens/home/components/snippets/CardHeaderCustom';
import RankingItem from '@/screens/home/components/snippets/RankingItem';
import SalesMember from '@/screens/home/components/snippets/SalesMember';
import BranchSearch from '@components/form/search/BranchSearch';
import SalesTeamSearch from '@components/form/search/SalesTeamSearch';

import {
  isWeb,
  isMobileWeb,
  isNative,
  fullWidth,
  fullHeight,
} from '@global/screens';
import Colors from '@global/colors';
import { REGIONAL } from '@/constants';

const propTypes = {
  data: PropTypes.array,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onBack: PropTypes.func,
};

const defaultProps = {
  data: [],
  style: {},
  onBack: () => {},
};

const widthMobile = fullWidth - 30;
const widthLeft = isWeb ? 'calc(100% - 300px)' : widthMobile;
const widthRight = isWeb ? 280 : widthMobile;

const TABS = [
  {
    label: 'National',
    value: 'national',
  },
  {
    label: 'Regional',
    value: 'regional',
  },
  {
    label: 'Branch',
    value: 'branch',
  },
  {
    label: 'Sales Team',
    value: 'sales_team',
  },
];

const SECTIONS = [
  {
    label: 'Individual Ranking',
    value: 'individual',
  },
  {
    label: 'Branch Ranking',
    value: 'branch',
  },
];

const RankingPerformance = (props) => {
  const { onBack } = props;

  const [filterRanking, setFilterRanking] = useState('');
  const [activeTab, setActiveTab] = useState('');
  const [activeSection, setActiveSection] = useState('individual');

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setActiveTab(TABS[0].value);
      setActiveSection(SECTIONS[0].value);
      setFilterRanking(TABS[0]);
    }
    return () => {
      mounted = false;
    };
  }, []);

  const FilterRanking = () => {
    let options = [];
    let optionLabel = 'label';
    let label = 'Filter';

    if (isWeb) {
      if (activeTab == 'regional') {
        options = REGIONAL;
        optionLabel = 'name';
        label = 'Regional';
      }
    } else {
      if (activeTab == 'regional') {
        options = REGIONAL;
        optionLabel = 'name';
        label = 'Regional';
      }
    }

    return (
      <View style={[styles.fullWidth, styles.rowBetween, styles.filterRow]}>
        {isWeb ? (
          <View style={styles.tabWrapper}>
            {TABS.map((item, idx) => (
              <TouchableOpacity
                activeOpacity={0.8}
                style={[
                  styles.tabItem,
                  activeTab == item.value ? styles.tabItemActive : {},
                ]}
                onPress={() => setActiveTab(item.value)}
                key={idx}>
                <SociollaText
                  style={[
                    styles.tabItemText,
                    activeTab == item.value ? styles.tabItemTextActive : {},
                  ]}>
                  {item.label}
                </SociollaText>
              </TouchableOpacity>
            ))}
          </View>
        ) : (
          <SociollaText style={styles.filterText}>Filter</SociollaText>
        )}
        <View style={styles.filterPeriod}>
          {!isWeb ? (
            <SelectBox
              label="Filter"
              hideLabel
              options={TABS}
              selectContainer={{
                marginBottom: activeTab != 'national' ? 10 : 0,
              }}
              value={TABS.find((t) => t.value == activeTab)}
              placeholder="Select Filter"
              trackBy="value"
              labelKey="label"
              isDropdown={isWeb}
              onChange={(value) => {
                setActiveTab(value?.value);
              }}
            />
          ) : (
            false
          )}
          {activeTab == 'regional' ? (
            <SelectBox
              label={label}
              hideLabel
              options={options}
              value={filterRanking}
              placeholder={`Select ${label}`}
              trackBy="value"
              labelKey={optionLabel}
              isDropdown={isWeb}
              onChange={(value) => {
                if (isWeb) {
                  setFilterRanking(value);
                } else {
                  setActiveTab(value?.value);
                }
              }}
            />
          ) : (
            false
          )}
          {activeTab == 'branch' ? (
            <BranchSearch
              hideLabel
              value={{}}
              arrayOne
              onChange={(value) => {
                console.log('branch', value);
              }}
            />
          ) : (
            false
          )}
          {activeTab == 'sales_team' ? (
            <SalesTeamSearch
              hideLabel
              value={{}}
              onChange={(value) => {
                console.log('sales-team', value);
              }}
            />
          ) : (
            false
          )}
        </View>
      </View>
    );
  };

  return (
    <>
      {isWeb && <Layout.Back title="Dashboard" onCallback={() => onBack()} />}
      {isWeb && <Layout.Title title="Rangking Performance" />}
      {!isWeb ? (
        <View style={[styles.tabWrapper, styles.tabSection]}>
          {SECTIONS.map((item, idx) => (
            <TouchableOpacity
              activeOpacity={0.8}
              style={[
                styles.tabItemSection,
                activeSection == item.value ? styles.tabItemSectionActive : {},
              ]}
              onPress={() => setActiveSection(item.value)}
              key={idx}>
              <SociollaText style={styles.tabItemSectionText}>
                {item.label}
              </SociollaText>
            </TouchableOpacity>
          ))}
          {activeSection == 'individual' ? (
            <>
              <FilterRanking {...props} />
            </>
          ) : (
            false
          )}
        </View>
      ) : (
        false
      )}
      <View
        style={[
          styles.fullWidth,
          styles.rowBetween,
          // eslint-disable-next-line react-native/no-inline-styles
          {
            marginTop:
              !isWeb && activeSection == 'individual'
                ? activeTab == 'national'
                  ? 100
                  : 170
                : 0,
          },
        ]}>
        {isWeb || activeSection == 'individual' ? (
          <View style={styles.leftSide}>
            {isWeb ? <FilterRanking {...props} /> : false}
            <View style={[styles.fullWidth, styles.rowBetween, styles.wrap]}>
              {[1, 2, 3, 4, 5, 5].map((item, idx) => (
                <SalesMember data={item} style={styles.salesMember} key={idx} />
              ))}
            </View>
          </View>
        ) : (
          false
        )}
        {isWeb || activeSection == 'branch' ? (
          <View
            style={[
              styles.rightSide,
              !isWeb ? styles.sectionBranchMobile : {},
            ]}>
            <View style={styles.defaultCardWidth}>
              <SociollaCard
                titleStyle={styles.titleStyle}
                style={isWeb ? styles.fullWidth : styles.cardBranchMobile}
                header={
                  isWeb ? (
                    <CardHeaderCustom title="Branch Ranking Leadership" />
                  ) : (
                    false
                  )
                }
                onPress={() => null}>
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, idx) => (
                  <RankingItem
                    data={item}
                    style={!isWeb ? styles.rankingMobile : {}}
                    index={idx}
                    key={idx}
                  />
                ))}
              </SociollaCard>
            </View>
          </View>
        ) : (
          false
        )}
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  defaultCardWidth: { width: '100%' },
  fullWidth: isWeb ? { width: '100%' } : { width: widthMobile },
  rowBetween: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  leftSide: {
    width: widthLeft,
  },
  rightSide: {
    width: widthRight,
  },
  titleStyle: {
    color: Colors.black0,
    fontSize: 15,
    lineHeight: 22,
  },
  filterText: {
    width: 40,
    color: Colors.grey1,
    fontSize: 12,
    marginTop: 15,
  },
  filterRow: {
    alignItems: 'center',
    backgroundColor: Colors.white,
    borderRadius: 5,
    padding: 15,
    zIndex: 1,
    elevation: 1,
    ...(!isWeb
      ? { marginBottom: 0, paddingVertical: 10, alignItems: 'flex-start' }
      : {}),
  },
  filterPeriod: {
    marginLeft: 15,
    ...(!isWeb
      ? {
          width: fullWidth - 85,
        }
      : {}),
  },
  wrap: { flexWrap: 'wrap' },
  salesMember: { width: isWeb ? '48%' : '100%' },
  tabWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  tabItem: {
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderBottomColor: Colors.transparent,
    borderBottomWidth: 2,
  },
  tabItemActive: {
    borderBottomColor: Colors.blue0,
  },
  tabItemText: {
    color: Colors.grey1,
  },
  tabItemTextActive: {
    color: Colors.black0,
  },
  tabSection: {
    width: fullWidth,
    backgroundColor: Colors.white,
    position: isNative ? 'absolute' : 'fixed',
    top: isMobileWeb ? 55 : 0,
    left: 0,
    right: 0,
    zIndex: 10,
    elevation: 10,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  tabItemSection: {
    width: '50%',
    padding: 10,
    borderBottomColor: Colors.transparent,
    borderBottomWidth: 2,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tabItemSectionActive: {
    borderBottomColor: Colors.blue0,
  },
  tabItemSectionText: {
    color: Colors.black0,
    textAlign: 'center',
  },
  sectionBranchMobile: {
    width: fullWidth,
    marginHorizontal: -15,
    marginTop: 25,
  },
  cardBranchMobile: {
    width: fullWidth,
    minHeight: fullHeight,
    marginBottom: -90,
    paddingHorizontal: 0,
    paddingTop: 0,
  },
  rankingMobile: { paddingHorizontal: 15, paddingVertical: 13 },
});

RankingPerformance.propTypes = propTypes;
RankingPerformance.defaultProps = defaultProps;

export default React.memo(RankingPerformance, (prev, next) => prev == next);
